import React, { useEffect, useContext } from "react";
import { MenuContext } from "../../../../contexts/shared";
import { Section, SidebarLayout } from "../../../../components/shared";
import {
  ServicesSessionsTables
} from "../../../../components/entrepreneur/services/sessions";

export function AssignationsSessionsIndex() {
  const { setMenuState } = useContext(MenuContext);

  /* set menu's current state */
  useEffect(() => {
    setMenuState({
      openKeys: ["entrepreneur/monitoring"],
      selectedKeys: ["entrepreneur/monitoring"]
    });
  }, []);

  return (
    <SidebarLayout>
      <Section spaced>
        <ServicesSessionsTables
          tableType="ASSIGNATIONS" />
      </Section>
    </SidebarLayout>
  );
}
